export const ROLES = {
    ADMIN: 'ADMIN',
    SITE_LEADER: 'SITE-LEADER',
    PRINCIPAL: 'PRINCIPAL',
    EDIFIER: 'COACH',
    TEACHER: 'TEACHER',
}